module.exports = __webpack_public_path__ + "img/pdfestados_pages-to-jpg-pendiente.549d9f35.jpg";